module.exports = __webpack_public_path__ + "static/media/Robot_blip-Marianne_Gagnon-120342607.b006268b.mp3";